var service = {
    mapLibraries: ['places']
};

service.API_URL = process.env.REACT_APP_BACKEND_URL;

export default service;
